define('lq/events/actions/thirdPartyLogin',[
    'jquery',
    'underscore',
    'lq',
    'lq/events/actions/eventAction'
], function ($, _, lq, EventAction) {
    'use strict';

    function ThirdPartyLogin(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(ThirdPartyLogin, EventAction);

    ThirdPartyLogin.typeName = 'ThirdPartyLogin';

    ThirdPartyLogin.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    var getParameterByName = function (parameterName) {
        parameterName = parameterName.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
        var regexS = "[\\?&]" + parameterName + "=([^&#]*)";
        var regex = new RegExp(regexS);
        var results = regex.exec(window.location.search);
        if (results == null)
            return "";
        else
            return decodeURIComponent(results[1].replace(/\+/g, " "));
    };

    ThirdPartyLogin.prototype.execute = function (continuation, eventActionResponse) {
        var commandId = getParameterByName('thirdPartyLoginCommandId');

        // Prevent loop when this is called during PageLoad
        if (!window.isThirdPartyLoginAfterPageLoad && this.eventData.command === commandId) {
            continuation();
            return;
        }

        //deliberately not calling continuation(), because it makes no sense to continue event execution after a login/redirect
        var appId = getParameterByName('AppId');

        var url = lq.getTenantUrl('LicquidAction/ThirdPartyLogin'
            + '?commandId=' + encodeURIComponent(this.eventData.command)
            + '&actionId=' + encodeURIComponent(this.piping.actionId)
            + (appId ? '&appId=' + appId : '')
            + '&returnUrl=' + encodeURIComponent(window.location.pathname + window.location.search));

        var parameters = {};

        var self = this;
        _.forEach(this.eventData.requiredParameters, function(theParameter) {
            parameters[theParameter] = self.piping.parameters.getValue(theParameter);
        });

        url += "&parameters=" + encodeURIComponent(JSON.stringify(parameters));

        window.location = url;
    };

    ThirdPartyLogin.prototype.handleError = function (eventName, defaultMessage, continuation) {
        if (this.eventIsEnabled(eventName)) {
            this.triggerEvent(eventName, continuation);
        } else {
            alert(defaultMessage);
            continuation();
        }
    };

    ThirdPartyLogin.afterPageLoad = function (eventing) {
        window.isThirdPartyLoginAfterPageLoad = true;
        
        var commandId = getParameterByName('thirdPartyLoginCommandId');
        var status = getParameterByName('thirdPartyLoginStatus');
        var returnUrl = getParameterByName('ReturnUrl');

        if ((!commandId || !status)) return;

        var continuation = function () { };
        var commandWasFound = false;

        _.each(eventing.events, function (event) {
            _.each(event.actions, function (eventAction) {
                if (commandWasFound) return;

                if (commandId) {
                    if (eventAction.command === commandId) {
                        commandWasFound = true;

                        var handler = new ThirdPartyLogin(eventAction);
                        handler.piping = eventing.piping;

                        if (status === 'Success') {
                            returnUrl = returnUrl || lq.getTenantUrl('');

                            if (handler.eventIsEnabled('updatingUserProperties')) {
                                handler.triggerEvent('updatingUserProperties', function () {
                                    eventing.piping.dispatcher.dispatch('LicquidAction/RefreshLoggedInUser')
                                        .then(function() {
                                            if (handler.eventIsEnabled('userLoggedIn'))
                                                handler.triggerEvent('userLoggedIn', continuation, returnUrl);
                                            else
                                                continuation();
                                        });
                                });
                            } else if (handler.eventIsEnabled('userLoggedIn')) {
                                handler.triggerEvent('userLoggedIn', continuation, returnUrl);
                            } else {
                                window.location = returnUrl;
                            }
                        } else if (status === 'InvalidCredentials')
                            handler.handleError('invalidCredentials',
                                'The credentials provided are invalid.',
                                continuation);
                        else if (status === 'UserNotFound')
                            handler.handleError('userNotFound',
                                'The user does not exist.',
                                continuation);
                        else if (status === 'AccountLocked')
                            handler.handleError('accountLocked',
                                'Your account has been locked out because of too many invalid login attempts.',
                                continuation);
                        else
                            alert('Unable to login.');
                    }
                }
            });
        });
    }
        
    return ThirdPartyLogin;
});
